import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { useraccountactivate, resetOnboarding } from '../../pages/Dashboard/onboardingSlice';
import { authenticate } from '../../pages/Auth/authSlice';
import { fetchProfile } from '../Settings/Profile/profileSlice';

const Header = ({ }) => {
    const dispatch = useDispatch();
    const profile = useSelector(state => state.auth.profile); 
    const profileData = useSelector(state => state.profile.profile);
    const activation = useSelector(state => state.onboarding && state.onboarding.activation);  
    const [alert, setAlert] = useState(false);
    const [snackOpen, setSnackOpen] = useState(false);
    const handleClose = () => {
        setSnackOpen(false);
        dispatch(resetOnboarding());
    };
    const handleVerify = () => {
        dispatch(useraccountactivate())
    }
    useEffect(() => {
        if (activation && activation.message && activation.hasErrors == false ) {
            setAlert(true)
            setSnackOpen(true)            
        } else if (activation && activation.hasErrors == true) {
            setAlert(true)
            setSnackOpen(true)
        }
    }, [activation && activation.message])

    useEffect(() => {
            dispatch(fetchProfile())
    }, [dispatch]);

    return (
        <>
            {alert &&
                <Snackbar
                    open={snackOpen}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    autoHideDuration={6000}
                    onClose={handleClose}
                >
                    <Alert severity={activation && activation.hasErrors === true ? "error" : "success"}
                        style={{ justifyContent: 'center', margin: "10px 0" }}
                    >
                        <span > {activation && activation.message}</span>
                    </Alert>
                </Snackbar>
            }
                    
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {profileData && profileData.status === 'PENDING' && profileData.id === 94 &&
                        typeof profileData.is_user_form_verfication_status !== 'undefined' &&
                        (profileData.verification_status !== "VERIFIED" || profileData.verification_status === null) && (
                            <Alert
                                severity="warning"
                                sx={{
                                    backgroundColor: "#ffcc80", // brighter orange background
                                    color: "#000",              // black text for readability
                                    fontWeight: "bold",
                                    display:'flex',
                                    alignItems:'center',       // bold text
                                    textAlign: "center",      // center the text
                                    py: 2,
                                    height:'50px'
                                }}
                                >
                                <p>
                                    We are currently processing your business verification. Please wait for further updates.
                                </p>
                            </Alert>
                        )
                    }

                    {profileData && profileData.status === 'PENDING' &&
                        profileData.activation_requested === true &&
                        ((profileData.verification_status === "VERIFIED" && profileData.id === 94) || profileData.id !== 94) && (
                                <Alert
                                severity="warning"
                                sx={{
                                    backgroundColor: "#ffcc80", // brighter orange background
                                    color: "#000",              // black text for readability
                                    fontWeight: "bold",
                                    display:'flex',
                                    alignItems:'center',       // bold text
                                    textAlign: "center",      // center the text
                                    py: 2,
                                    height:'50px'
                                }}
                                >
                                <p>
                                    Your account is on verifying process yet to be activated
                                </p>
                            </Alert>
                        )
                    }

                    {profileData && profileData.status === 'PENDING' &&
                        profileData.activation_requested === false &&
                        ((profileData.verification_status === "VERIFIED" && profileData.id === 94) || profileData.id !== 94) && (
                            <>
                                <Alert
                                severity="warning"
                                sx={{
                                    backgroundColor: "#ffcc80", // brighter orange background
                                    color: "#000",              // black text for readability
                                    fontWeight: "bold",
                                    display:'flex',
                                    alignItems:'center',       // bold text
                                    textAlign: "center",      // center the text
                                    py: 2,
                                    height:'50px'
                                }}
                                >
                                <div style={{display:'flex',alignItems:'center'}}>
                                    <p style={{ margin: 0, fontWeight: 'bold' }}>
                                        Add a valid payment method to continue printing labels.
                                    </p>
                                    <Link to="/settings/payment" style={{ textDecoration: 'none' }}>
                                        <Button
                                        variant="outlined"
                                        sx={{
                                            color: '#000',
                                            border: '1px solid #000',
                                            fontWeight: 'bold',
                                            marginLeft:'10px'
                                        }}
                                        >
                                        Add credit card
                                        </Button>
                                    </Link>
                                </div>
                                </Alert>
                            </>
                        )
                    }
                </div>
                    
        </>
    )

}

export default Header;
